import { type CheckedState } from '@radix-ui/react-checkbox'

import { type CaseNavigationProps } from '@/pages/client-portal/ui/case-navigation/case-navigation'

import { useSheet } from '@/lib/hooks/use-sheet'
import { useClientPortalInternalSampleStore } from '@/lib/stores/client-portal-internal-sample-store'

import { type ClientPortalOptionForm } from '../../../ui/client-portal-internal-header/portal-control/portal-control-sheet/types'

export const useClientPortalInternalSampleHeader = () => {
  const {
    currentCase,
    allApplicantCases,
    selectedCases,
    goToCase,
    goToPreviousCase,
    goToNextCase,
    updateCheckedCase,
    updatePortalOption,
  } = useClientPortalInternalSampleStore()

  const {
    isSheetOpen: isOpenPortalControlSheet,
    openSheet: openPortalControlSheet,
    closeSheet: closePortalControlSheet,
  } = useSheet()

  const handleChangeCaseChecked = (caseId: number, checked: CheckedState) => {
    updateCheckedCase(caseId, checked)
  }

  const handleClickPortalControlTriggerButton = () => {
    openPortalControlSheet()
  }

  const handleChangePortalControlSheetOpen = (open: boolean) => {
    open ? openPortalControlSheet() : closePortalControlSheet()
  }

  const handleClickPortalControlSaveButton = (data: ClientPortalOptionForm) => {
    updatePortalOption({ ...data, caseId: currentCase.caseId })
    closePortalControlSheet()
  }

  const handleClickPreviousButton = () => {
    goToPreviousCase()
  }

  const handleClickCase: CaseNavigationProps['onClickCase'] = (caseItem) => {
    goToCase(caseItem.caseId)
  }

  const handleClickNextButton = () => {
    goToNextCase()
  }

  return {
    currentCaseId: currentCase.caseId,
    currentCaseNumber: currentCase.caseNumber,
    dataAllApplicantCases: allApplicantCases,
    dataProUserSelectedCases: selectedCases,
    defaultPortalOption: currentCase.portalOption,
    isUscisCase: currentCase.isUscisCase,
    isOpenPortalControlSheet,
    handleChangeCaseChecked,
    handleClickPortalControlTriggerButton,
    handleChangePortalControlSheetOpen,
    handleClickPortalControlSaveButton,
    handleClickPreviousButton,
    handleClickCase,
    handleClickNextButton,
  }
}
